import styled from 'styled-components';

export const ExpandedMobileItemLabel = styled.div`
  display: table-cell;
  padding-right: 6px;
`;
